import defaultItemRendererText from './default-item-renderer-text';
import ListItemRenderer from './list-item-renderer';
import type Text from './text';

/**
 * If the ItemRenderer property is not defined in the List component, this component will be used as a temporary renderer until the ItemRenderer property is set.
 *
 * If the item type is a string, that string will be shown, otherwise the item will be cast to a string type and displayed.
 */
export default class DefaultListItemRenderer<Item> extends ListItemRenderer<Item> {
	#text: Text;
	public constructor() {
		super();
		this.#text = defaultItemRendererText();
		this.alignment = 'left';
		this.height = 32;
		this.paddingHorizontal = 8;
		this.width = 'fill';
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.#text);
	}

	protected override itemChanged(): void {
		super.itemChanged();
		this.#text.text = String(this.item);
	}
}
customElements.define('ac-default-list-item-renderer', DefaultListItemRenderer);
